import React from 'react';
import { Box, Divider, Stack, Typography, alpha } from '@mui/material';
import { LockOutlined, PersonOutline } from '@mui/icons-material';
import ChangePasswordForm from './ChangePasswordForm';
import ChangeProfileForm from './ChangeProfileForm';

const BRAND = '#0c5bab';

// Shared look for the antd forms inside this page
const formStyles = {
  '& .ant-form-item-label > label': {
    fontWeight: 600,
    fontSize: 13,
    color: 'text.secondary',
  },
  '& .form-control, & .form-control.ant-input-affix-wrapper': {
    borderRadius: '10px !important',
    borderColor: '#d0d5dd',
    minHeight: 42,
    transition: 'border-color 0.2s, box-shadow 0.2s',
    '&:hover': { borderColor: BRAND },
  },
  '& .form-control:focus, & .ant-input-affix-wrapper-focused': {
    borderColor: `${BRAND} !important`,
    boxShadow: `0 0 0 3px ${alpha(BRAND, 0.12)} !important`,
  },
  '& .form-control[disabled]': { bgcolor: '#f4f6f8 !important', color: 'text.secondary' },
  '& .save_btn': { borderRadius: '10px', fontWeight: 700, px: 3, mt: 2 },
  '& .ant-form-item:last-child': { mb: 0 },
};

const Section = ({ icon, title, description, children }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: { xs: '1fr', lg: '240px minmax(0, 1fr)' },
      gap: { xs: 2, lg: 4 },
    }}
  >
    <Stack direction="row" spacing={1.5} alignItems="flex-start">
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: '10px',
          display: 'grid',
          placeItems: 'center',
          bgcolor: alpha(BRAND, 0.08),
          color: BRAND,
          flexShrink: 0,
          '& svg': { fontSize: 20 },
        }}
      >
        {icon}
      </Box>
      <Box>
        <Typography variant="subtitle1" fontWeight={700} lineHeight={1.3}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {description}
        </Typography>
      </Box>
    </Stack>
    <Box sx={formStyles}>{children}</Box>
  </Box>
);

const ProfileContent = () => (
  <Stack spacing={4} divider={<Divider flexItem />}>
    <Section
      icon={<PersonOutline />}
      title="Personal information"
      description="Update your name and phone number. Your email address can't be changed."
    >
      <ChangeProfileForm />
    </Section>

    <Section
      icon={<LockOutlined />}
      title="Password"
      description="Use at least 7 characters, including an uppercase letter, a lowercase letter and a number."
    >
      <ChangePasswordForm />
    </Section>
  </Stack>
);

export default ProfileContent;
